import { createContext, useContext } from "react";

type AssessmentGradingFormContextType = {
  isAiAssessmentLoading: boolean;
  setIsAiAssessmentLoading: (loading: boolean) => void;
};

export const AssessmentGradingFormContext = createContext<
  AssessmentGradingFormContextType | undefined
>(undefined);

export const useAssessmentGradingFormContext = () => {
  const ctx = useContext(AssessmentGradingFormContext);
  if (!ctx)
    throw new Error(
      "useAssessmentGradingFormContext must be used within AssessmentGradingFormProvider",
    );
  return ctx;
};
